// Tiny pub/sub for in-app notifications.
const listeners = new Map();
let nextId = 1;

export const eventBus = {
  on(event, fn) {
    const id = nextId++;
    if (!listeners.has(event)) listeners.set(event, new Map());
    listeners.get(event).set(id, fn);
    return () => listeners.get(event)?.delete(id);
  },
  emit(event, payload) {
    const subs = listeners.get(event);
    if (!subs) return;
    for (const fn of subs.values()) {
      try { fn(payload); } catch (err) { console.error(err); }
    }
  },
};
